import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Url } from './../../../shared/constants/url-constants';

const authHeaders = new HttpHeaders({
  'Content-Type': 'application/json'
});

@Injectable({
  providedIn: 'root'
})
export class TogetherModeModalService {
  togetherModeEnabled: boolean;
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: HTMLDocument
  ) {}

  public readonly showEnterTogetherMode = new Subject<any>();
  public readonly hideEnterTogetherMode = new Subject<any>();

  showEnterTogetherMode$ = this.showEnterTogetherMode.asObservable();
  hideEnterTogetherMode$ = this.hideEnterTogetherMode.asObservable();
  
  openModal() {
    this.showEnterTogetherMode.next({});
    const usernameInput = this.document.getElementById('id-username')
    setTimeout(() => {
      usernameInput.focus();
    })
  }

  closeModal() {
    this.hideEnterTogetherMode.next({});
  }

  enterTogetherMode(formData: any) {
    const body = JSON.stringify(formData);
    return this.http.post<any>(`${Url.USER_MANAGEMENT}/virtual-campus/together-mode/login`, body, { headers: authHeaders, observe: 'response' })
    .pipe(
      tap(response => {
        this.setTogetherModeTrue();
        this.hideEnterTogetherMode.next({});
      })
    );
  }

  exitTogetherMode() {
    const body = {};
    return this.http.put<any>(`${Url.PLAN}/together-mode/logout-session`, body, { headers: authHeaders, observe: 'response' })
    .pipe(
      tap(response => {
        this.setTogetherModeFalse();
        this.hideEnterTogetherMode.next({});
      })
    );
  }

  resolveTogetherModeStatus() {
    localStorage.getItem('sessionTM') ? this.togetherModeEnabled = true : this.togetherModeEnabled = false; 
  }

  getTogetherModeEnabledStatus() {
    return this.togetherModeEnabled;
  }

  setTogetherModeTrue() {
    const encodedString = Base64.encode('enabled');
    localStorage.setItem('sessionTM', encodedString);
    this.togetherModeEnabled = true;
  }

  setTogetherModeFalse() {
    localStorage.removeItem('sessionTM');
    this.togetherModeEnabled = false;
    if (this.router.url.includes('/plan/induction')) {
      this.router.navigateByUrl('/plan');
    }
  }

}
